import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { params, string, shape, useDataModel } from '@thd-nucleus/data-sources';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { CountdownTimer } from '@thd-olt-component-react/countdown-timer';

import * as analytics from './analytics/PromotionsAnalytics';
import './promotion.style.scss';

const Promotion = ({ itemId, hideConditionalPromoDescription }) => {
  const { channel } = useContext(ExperienceContext);
  const storeId = useStoreId();
  const { data } = useDataModel('product', { variables: { itemId, storeId } });

  if (!data) return null;

  const { description, dates } = data?.product?.pricing?.promotion || {};

  if (hideConditionalPromoDescription) return null;

  const { shortDesc, longDesc } = description || {};

  if (!shortDesc) return null;

  const { end, start } = dates || {};

  const specialBuy = {
    'Online Exclusive Special Buy of the Day': {
      link: '/SpecialBuy/SpecialBuyOfTheDay',
      description: 'Shop All Special Buy of the Day',
    },
    'Online Exclusive Pro Special Buy of the Week': {
      link: '/SpecialBuy/ProSpecialBuyOfTheWeek',
      description: 'Shop All Pro Special Buy of the Week',
    },
    'Online Exclusive Decor Special Buy of the Week': {
      link: '/SpecialBuy/DecorSpecialBuyOfTheWeek',
      description: 'Shop All Decor Special Buy of the Week',
    }
  };

  return (
    <div data-testid="promotion">
      {!specialBuy[shortDesc] && (
        <div className="promotion">
          <Tooltip
            channel={channel}
            content={(
              <div>
                <b>Promotion Details</b>
                <div className="promotion__tooltip">{`Price Valid: ${start} - ${end}`}</div>
                {longDesc && <div>{longDesc}</div>}
                {!longDesc && <div>{shortDesc}</div>}
              </div>
            )}
            closeButton
          >
            <button
              type="button"
              className="promotion__link"
              href="#"
              onClick={analytics.promoClickEvent}
            >
              {shortDesc}
            </button>
          </Tooltip>
        </div>
      )}
      {specialBuy[shortDesc] && (
        <div className="promotion__special-buy-wrapper">
          <div className="promotion__special-buy-icon" />
          <div>
            <div className=" promotion__special-buy-timer">Special Buy ends in&nbsp;
              <CountdownTimer
                isPromotionTimer
                endDate={end}
              />
            </div>
            <a className="promotion__special-buy-link" href={specialBuy[shortDesc].link}>
              {specialBuy[shortDesc].description}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

Promotion.displayName = 'Promotion';

Promotion.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    dataSources: string(),
    pricing: params({ storeId: string() }).shape({
      promotion: shape({
        dates: shape({
          start: string(),
          end: string()
        }),
        description: shape({
          shortDesc: string(),
          longDesc: string()
        }),
      })
    })
  })
};

Promotion.propTypes = {
  /**
  * To display the Item Id
  */
  itemId: PropTypes.string.isRequired,
  /**
  * To hide the promotion description
  */
  hideConditionalPromoDescription: PropTypes.bool
};

Promotion.defaultProps = {
  hideConditionalPromoDescription: false
};

export default Promotion;
